<ng-container *ngIf="source$ | async as source; else loading">
  <ng-container
    *ngTemplateOutlet="
      favoriteFilter;
      context: {
        columnFilters: source.columnFilters,
        operatorFilters: source.operatorFilters,
        $implicit: selected
      }
    "
  ></ng-container>
</ng-container>
<ng-template #loading>
  <ng-container
    *ngTemplateOutlet="favoriteFilter; context: { columnFilters: { items: [] }, operatorFilters: { items: [] }, data: selected }"
  ></ng-container>
</ng-template>

<ng-template #favoriteFilter let-columnFilters="columnFilters" let-operatorFilters="operatorFilters" let-selected>
  <div class="search">
    <iu-prime-chips
      [(ngModel)]="filterChips"
      [buildItemOnSave]="buildChipsOnSave"
      [conditionToAdd]="conditionToAdd"
      (onAdd)="addFilterByChips($event.originalEvent, $event.value)"
      (onRemove)="removeFilterByChips($event.originalEvent, $event.value)"
      (addError)="onAddError()"
      [shouldBeSmall]="gridView?.isGridCollapsed && gridView?.isTabTopLevel"
      [preventInput]="gridView?.isGridCollapsed && gridView?.isTabTopLevel"
      [widthChipsContainer]="gridView?.isTabTopLevel ? undefined : 270"
      data-cy="universal-filter-chips"
    >
      <ng-template let-item pTemplate="item">
        <span
          *ngIf="item"
          class="{{ item?.icon }}"
          [attr.data-cy-chips-columnName]="item?.columnName"
          style="margin-right: 3px"
        ></span
        >{{ item?.displayValue }}
      </ng-template>
    </iu-prime-chips>
    <span *ngIf="isFromWindow" [ngClass]="['favorite']">
      <button
        tooltipPosition="top"
        showDelay="250"
        life="3"
        pTooltip="{{ 'universalFilter.favorite' | translate }}"
        pButton
        type="button"
        icon="icon-ico-favorite"
        class="p-menu-bar-button favorite"
        (click)="
          updatePanelFilter($event, 'FavoriteFilter', 'favorite-filter-panel');
          updatePanelFilter($event, 'GroupFilter', 'group-filter-panel', false);
          loadData($event)
        "
        data-cy="universal-filter-favorite"
      ></button>
      <div *ngIf="isDisplayFavoriteFilter" id="favorite-filter-panel" class="favorite-options ui-overlaypanel">
        <div class="save-favorite">
          <input #filterFavorite [(ngModel)]="selectedLabel" type="text" class="name" class="p-inputtext ui-corner-all" />
          <button
            tooltipPosition="top"
            showDelay="250"
            life="3"
            pTooltip="{{ 'generic.save' | translate }}"
            pButton
            type="button"
            icon="icon-ico-save3x"
            class="save"
            (click)="saveFilter($event, filterFavorite.value)"
          ></button>
        </div>
        <div class="saved-list">
          <ul>
            <ng-container *ngFor="let item of dataToDisplay">
              <li
                [ngClass]="[selectedLabel === item.favorite ? 'universal-filter-selected' : '']"
                (click)="selectAndApply($event, item)"
              >
                <a class="charge">{{ item.favorite }}</a>
                <div class="edit">
                  <button
                    tooltipPosition="top"
                    showDelay="250"
                    life="3"
                    pTooltip="{{ 'generic.edit' | translate }}"
                    pButton
                    type="button"
                    icon="icon-ico-super-power"
                    class="hover"
                    (click)="selectFilter($event, item)"
                  ></button>
                </div>
                <div class="delete">
                  <button
                    tooltipPosition="top"
                    showDelay="250"
                    life="3"
                    pTooltip="{{ 'generic.delete' | translate }}"
                    pButton
                    type="button"
                    icon="icon-ico-delete"
                    class="hover"
                    (click)="deleteFilter($event, item)"
                  ></button>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </span>

    <span [ngClass]="[isDisplayGroupFilter ? 'opened' : '', 'group']">
      <button
        tooltipPosition="top"
        showDelay="250"
        life="3"
        pTooltip="{{ 'universalFilter.filter' | translate }}"
        pButton
        type="button"
        icon="icon-ico-advanced-search-3"
        (click)="
          updatePanelFilter($event, 'GroupFilter', 'group-filter-panel');
          updatePanelFilter($event, 'FavoriteFilter', 'favorite-filter-panel', false)
        "
        class="p-menu-bar-button group"
        data-cy="universal-filter-setting"
      ></button>
      <div *ngIf="isDisplayGroupFilter" id="group-filter-panel" class="group-list ui-overlaypanel {{ isMobile ? 'mobile' : '' }}">
        <p
          *ngIf="selected.filters.length > 0"
          [ngStyle]="{ order: gridView?.viewType === 'kanban' ? 1 : 0 }"
          style="padding-top: 5px"
        >
          {{ 'universalFilter.filterTitle' | translate }}
        </p>
        <ul
          #filtersContainer
          *ngIf="selected.filters.length > 0"
          [ngStyle]="{ order: gridView?.viewType === 'kanban' ? 1 : 0 }"
          cdkDropList
          (cdkDropListDropped)="moveItem($event, 'filters')"
          data-uf="filters"
        >
          <div
            *ngFor="let filter of selected.filters; first as isFirst; last as isLast; index as i"
            cdkDrag
            data-cy="universal-filter-filter"
            [attr.data-cy-index]="i"
          >
            <div class="ui-row-drag-preview" *cdkDragPreview>
              <!-- Preview du drag -->{{ 'universalFilter.filterPreview' | translate
              }}{{ filter.column.displayValue || '[ColumnName]' }}
              {{ filter.operator.displayValue || '[Operator]' }}
              {{ filter.filter || '[Filter]' }}
              {{
                filter.filterTo !== undefined && filter.filterTo !== null && filter.filterTo !== '' ? ' - ' + filter.filterTo : ''
              }}
            </div>
            <div class="ui-row-drag-placeholder" *cdkDragPlaceholder><!-- Placeholder du drag --></div>
            <li class="ui-row" [attr.data-cy-row]="filter.column.id">
              <div class="filtres">
                <span cdkDragHandle class="icon-ico-grab" style="font-size: 17px; cursor: move"></span>
                <div class="lev-1 filter-field" data-cy="universal-filter-column-autocomplete">
                  <iu-autocomplete-ui
                    [fieldValue]="filter.column"
                    (fieldValueModified)="setColumnFilter($event, i)"
                    [isStandalone]="true"
                    [data]="
                      columnFilters
                        | universalFilterColFilterType: 0:i:(gridView?.viewType === 'calendar' ? 'date' : 'none')
                        | universalFilterColFilter: usedFilterColumnNames
                    "
                    [isInUniversalFilter]="true"
                    [isInsideOverflow]="true"
                  ></iu-autocomplete-ui>
                </div>

                <div class="lev-2 filter-field" data-cy="universal-filter-operator-autocomplete">
                  <iu-autocomplete-ui
                    [fieldValue]="filter.operator"
                    (fieldValueModified)="setOperatorFilter($event, i)"
                    [isStandalone]="true"
                    [data]="operatorFilters | operatorFilter: filter?.column?.columnInfo?.filterType"
                    [isInUniversalFilter]="true"
                    [isInsideOverflow]="true"
                  ></iu-autocomplete-ui>
                </div>

                <div class="lev-3 filter-field" data-cy="universal-filter-value">
                  <ng-template #vcrFilter></ng-template>
                </div>
                <div class="lev-4 filter-field" data-cy="universal-filter-value-to">
                  <!-- <ng-template #vcrFilterTo></ng-template> -->
                  <iu-input-number-ui
                    *ngIf="filter?.operator?.operator?.isRange && filter?.column?.columnInfo?.filterType === 'number'"
                    [isStandalone]="true"
                    [fieldValue]="filter.filterTo"
                    (fieldValueModified)="setFilterTo($event, i)"
                  ></iu-input-number-ui>
                  <iu-calendar-ui
                    *ngIf="filter?.operator?.operator?.isRange && filter?.column?.columnInfo?.filterType === 'date'"
                    [isStandalone]="true"
                    [fieldValue]="filter.filterTo"
                    (fieldValueModified)="setFilterTo($event, i)"
                  ></iu-calendar-ui>
                </div>
              </div>
              <div class="delete" data-cy="universal-filter-remove-filter">
                <button
                  tooltipPosition="top"
                  showDelay="250"
                  life="3"
                  pTooltip="{{ 'generic.delete' | translate }}"
                  pButton
                  icon="icon-ico-delete"
                  class="hover"
                  (click)="removeFilter(i, $event)"
                ></button>
              </div>
            </li>
          </div>
        </ul>
        <ul *ngIf="selected.filters.length > 0" class="buttonAdd" [ngStyle]="{ order: gridView?.viewType === 'kanban' ? 1 : 0 }">
          <li class="ui-row">
            <div class="p-col-12">
              <!-- au clic créaction d'un nouvel Li au-dessus de celui-ci et contenant un pemier auto-complete-->
              <button
                pButton
                id="addrow"
                *ngIf="canFilter"
                class="button p-button-secondary"
                style="cursor: pointer"
                (click)="addFilter($event)"
                label="{{ 'universalFilter.addFilter' | translate }}"
                icon="icon-ico-add"
                data-cy="universal-filter-add-filter-one"
              ></button>
            </div>
          </li>
        </ul>
        <p
          *ngIf="selected.groups.length > 0"
          [ngStyle]="{ order: gridView?.viewType === 'kanban' ? 0 : 1 }"
          style="padding-top: 5px"
        >
          {{ 'universalFilter.groupTitle' | translate }}
        </p>
        <ul
          #groupsContainer
          *ngIf="selected.groups.length > 0"
          [ngStyle]="{ order: gridView?.viewType === 'kanban' ? 0 : 1 }"
          cdkDropList
          (cdkDropListDropped)="moveItem($event, 'groups')"
          data-uf="groups"
        >
          <div
            *ngFor="let group of selected.groups; first as isFirst; last as isLast; index as i"
            data-cy="universal-filter-group"
            [attr.data-cy-index]="i"
            cdkDrag
          >
            <div class="ui-row-drag-preview" *cdkDragPreview>
              <!-- Preview du drag -->{{ 'universalFilter.groupPreview' | translate }}{{ group.displayValue || '[ColumnName]' }}
            </div>
            <div class="ui-row-drag-placeholder" *cdkDragPlaceholder><!-- Placeholder du drag --></div>
            <li class="ui-row">
              <div class="filtres">
                <span cdkDragHandle class="icon-ico-grab" style="font-size: 17px; cursor: move"></span>
                <div class="lev-1 filter-field" data-cy="universal-filter-group-autocomplete">
                  <iu-autocomplete-ui
                    [fieldValue]="group"
                    (fieldValueModified)="setGroup($event, i)"
                    [isStandalone]="true"
                    [data]="columnFilters | columnGroupFilter: isFromWindow"
                    [isInUniversalFilter]="true"
                    [isInsideOverflow]="true"
                  ></iu-autocomplete-ui>
                </div>
                <div class="delete" data-cy="universal-filter-remove-group">
                  <button
                    tooltipPosition="top"
                    showDelay="250"
                    life="3"
                    pTooltip="{{ 'generic.delete' | translate }}"
                    pButton
                    icon="icon-ico-delete"
                    class="hover"
                    (click)="removeGroup(i, $event)"
                  ></button>
                </div>
              </div>
            </li>
          </div>
        </ul>
        <ul
          *ngIf="selected.groups.length > 0"
          class="buttonAdd"
          [ngStyle]="{ order: gridView?.viewType === 'kanban' ? 0 : 1 }"
          style="padding-top: 5px"
        >
          <li class="ui-row">
            <div class="p-col-12">
              <!-- au clic créaction d'un nouvel Li au-dessus de celui-ci et contenant un pemier auto-complete-->
              <button
                pButton
                *ngIf="canGroup"
                class="button p-button-secondary"
                style="cursor: pointer"
                (click)="addGroup($event)"
                label="{{ 'universalFilter.addGroup' | translate }}"
                icon="icon-ico-add"
                data-cy="universal-filter-add-group-one"
              ></button>
            </div>
          </li>
        </ul>
        <p *ngIf="selected.sortings.length > 0" [ngStyle]="{ order: 2 }" style="padding-top: 5px">
          {{ 'universalFilter.sortingTitle' | translate }}
        </p>
        <ul
          #sortsContainer
          *ngIf="selected.sortings.length > 0"
          [ngStyle]="{ order: 2 }"
          cdkDropList
          (cdkDropListDropped)="moveItem($event, 'sortings')"
          data-uf="sortings"
        >
          <div
            *ngFor="let sorting of selected.sortings; first as isFirst; last as isLast; index as i"
            data-cy="universal-filter-sort"
            [attr.data-cy-index]="i"
            cdkDrag
          >
            <div class="ui-row-drag-preview" *cdkDragPreview>
              <!-- Preview du drag -->{{ 'universalFilter.sortingPreview' | translate
              }}{{ sorting.column.displayValue || '[ColumnName]' }} {{ sorting.sortingType }}
            </div>
            <div class="ui-row-drag-placeholder" *cdkDragPlaceholder><!-- Placeholder du drag --></div>
            <li class="ui-row">
              <div class="filtres">
                <span cdkDragHandle class="icon-ico-grab" style="font-size: 17px; cursor: move"></span>
                <div class="lev-1 filter-field" data-cy="universal-filter-sort-autocomplete">
                  <iu-autocomplete-ui
                    [fieldValue]="sorting.column"
                    (fieldValueModified)="setSorting($event, i)"
                    [disable]="true"
                    [isStandalone]="true"
                    [data]="columnFilters"
                    [isInUniversalFilter]="true"
                    [isInsideOverflow]="true"
                  ></iu-autocomplete-ui>
                </div>
                <li class="asc-desc filter-field">
                  <div class="p-col-2 asc">
                    <input
                      type="radio"
                      name="sorting_{{ i }}"
                      value="asc"
                      checked="{{ sorting.sortingType === 'asc' ? 'checked' : null }}"
                      [(ngModel)]="sorting.sortingType"
                      label="asc"
                      data-cy="universal-filter-sort-type-asc"
                    /><label id="asc">asc</label>
                  </div>
                  <div class="p-col-2 desc">
                    <input
                      type="radio"
                      name="sorting_{{ i }}"
                      value="desc"
                      checked="{{ sorting.sortingType === 'desc' ? 'checked' : null }}"
                      [(ngModel)]="sorting.sortingType"
                      label="desc"
                      data-cy="universal-filter-sort-type-desc"
                    /><label id="desc">desc</label>
                  </div>
                </li>
                <div class="delete" data-cy="universal-filter-remove-sort">
                  <button
                    tooltipPosition="top"
                    showDelay="250"
                    life="3"
                    pTooltip="{{ 'generic.delete' | translate }}"
                    pButton
                    icon="icon-ico-delete"
                    class="hover"
                    (click)="removeSorting(i, $event)"
                  ></button>
                </div>
              </div>
            </li>
          </div>
        </ul>
        <ul *ngIf="selected.sortings.length > 0" class="buttonAdd" [ngStyle]="{ order: 2 }">
          <li class="ui-row">
            <div class="p-col-12">
              <!-- au clic créaction d'un nouvel Li au-dessus de celui-ci et contenant un pemier auto-complete-->
              <button
                pButton
                *ngIf="canSort"
                class="button p-button-secondary"
                style="cursor: pointer"
                (click)="addSorting($event)"
                label="{{ 'universalFilter.addSorting' | translate }}"
                icon="icon-ico-add"
                data-cy="universal-filter-add-sort-one"
              ></button>
            </div>
          </li>
        </ul>
        <div class="actions ui-row">
          <div class="action">
            <a
              *ngIf="canFilter && selected.filters.length <= 0"
              class="button p-button-secondary action-btn"
              style="cursor: pointer"
              (click)="addFilter($event)"
              data-cy="universal-filter-add-filter-none"
              ><span class="icon-ico-add"></span>{{ 'universalFilter.addFilter' | translate }}
            </a>
            <a
              *ngIf="canGroup && selected.groups.length <= 0"
              class="button p-button-secondary action-btn"
              style="cursor: pointer"
              (click)="addGroup($event)"
              data-cy="universal-filter-add-group-none"
              ><span class="icon-ico-add"></span>{{ 'universalFilter.addGroup' | translate }}
            </a>
            <a
              *ngIf="canSort && selected.sortings.length <= 0"
              class="button p-button-secondary action-btn"
              style="cursor: pointer"
              (click)="addSorting($event)"
              data-cy="universal-filter-add-sort-none"
              ><span class="icon-ico-add"></span>{{ 'universalFilter.addSorting' | translate }}
            </a>
          </div>
          <div class="action right">
            <button
              type="button"
              pButton
              label="{{ 'generic.apply' | translate }}"
              class="p-button primary"
              (click)="applyFilter($event)"
              data-cy="apply-filter-btn"
            ></button>
            <button
              type="button"
              pButton
              label="{{ 'universalFilter.resetFilters' | translate }}"
              class="p-button primary"
              (click)="resetFilters($event)"
              data-cy="reset-filter-btn"
            ></button>
          </div>
        </div>
      </div>
    </span>
  </div>
</ng-template>

<!-- <li *ngIf="!isFirst" class="ui-row">
  <div class=" p-col-2 and">
    <input
      type="radio"
      name="link_{{ i }}"
      checked="{{ filter.link === 'and' ? 'checked' : null }}"
      [(ngModel)]="filter.link"
      value="and"
      label="Et"
    /><label id="Et">Et</label>
  </div>
  <div class=" p-col-2 or">
    <input
      type="radio"
      name="link_{{ i }}"
      checked="{{ filter.link === 'or' ? 'checked' : null }}"
      [(ngModel)]="filter.link"
      value="or"
      label="Ou"
    /><label id="Ou">Ou</label>
  </div>
</li> -->
